// extracted by mini-css-extract-plugin
export default {"productDescription":"Eda-z","featuredDescription":"Fda-z","description":"Gda-z","more":"Hda-z","descriptionSku":"Ida-z"};